module.exports = __webpack_public_path__ + "img/I58A5028@2x.ef097a36.png";